export default "__VITE_ASSET__DohIiKj9__"